import clsx from "clsx";
import { UseFormRegisterReturn } from "react-hook-form";

import {
  FieldWrapperPassThroughProps,
  Option,
  TextValueModel,
} from "@/types/common";

import { FieldWrapper } from "./FieldWrapper";

type SelectFieldProps = FieldWrapperPassThroughProps & {
  options: Option[] | TextValueModel[];
  className?: string;
  fieldWrapperClassName?: string;
  defaultValue?: string;
  registration: Partial<UseFormRegisterReturn>;
};

export const SelectField = (props: SelectFieldProps) => {
  const {
    label,
    options,
    error,
    className,
    fieldWrapperClassName,
    defaultValue,
    registration,
  } = props;
  return (
    <FieldWrapper label={label} error={error} className={fieldWrapperClassName}>
      <select
        name="location"
        className={clsx(
          "mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md",
          className
        )}
        defaultValue={defaultValue}
        {...registration}
      >
        <option value="">Please Select</option>
        {options &&
          options.map(({ text, value }) => (
            <option key={text?.toString()} value={value}>
              {text}
            </option>
          ))}
      </select>
    </FieldWrapper>
  );
};
